import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import ImporterCard from './ImporterCard';
import { importerCardStyles } from './styles';
import AddOrEditImporter from './AddOrEditImporter';

export default function ImportersList() {
  const [isLoading, setIsLoading] = useState(false);
  const [importers, setImporters] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewImporterModalOpen, setAddNewImporterModalOpen] = useState(false);

  const getImporters = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/importer/?search=${searchText}`)
      .then(res => {
        setImporters(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewImporterModalClose = () => {
    getImporters();
    setAddNewImporterModalOpen(false);
  };

  useEffect(() => {
    // Fetch importers on mount
    getImporters();
  }, [getImporters]);

  return (
    <>
      <SearchBar label="Search an importer..." setQuery={setSearchText} />
      <div style={importerCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewImporterModalOpen(true)}>
          Importer
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={importers}
            emptyMessage="No importers found."
            // @ts-ignore
            CardComponent={ImporterCard}
            onImporterDelete={getImporters}
            onImporterUpdate={getImporters}
          />
          <AddOrEditImporter
            onSave={onNewImporterModalClose}
            modalTitle="Add new importer"
            isModalOpen={addNewImporterModalOpen}
            setModalOpen={setAddNewImporterModalOpen}
          />
        </>
      )}
    </>
  );
}
